import { AppEnvironment } from 'sham-components/services/core/app-environment';
import { API_BASE_URL, MEDIA_BASE_URL } from '@/environments/environment';

export async function appEnvFactory(appEnv: AppEnvironment) {
  appEnv.BASE_URL.set(API_BASE_URL);
  appEnv.API_BASE_URL.set(`${API_BASE_URL}/api`);
  appEnv.MEDIA_BASE_URL.set(MEDIA_BASE_URL);
}
